import { rest } from "msw";
import { getListMock } from "../services/service.js";
function createRestHandler(option, mockMethod, mockPath, delay) {
  return rest[mockMethod](mockPath, (_req, res, ctx) => {
    return res(
      ctx.status(option.status),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ctx.json(option.data),
      ctx.delay(delay)
    );
  });
}
function createHandler(groupMockDebugs) {
  const activeMocks = getListMock();
  const allHandlers = [];
  Object.entries(activeMocks).forEach(([key, value]) => {
    groupMockDebugs.forEach((mocks) => {
      mocks.list.forEach((mock) => {
        if (mock.title === key) {
          mock.options.forEach((option) => {
            if (option.id === value && "status" in option) {
              allHandlers.push(
                createRestHandler(
                  option,
                  mock.method,
                  mock.path,
                  mock.delay
                )
              );
            }
          });
        }
      });
    });
  });
  return allHandlers;
}
export {
  createHandler
};
//# sourceMappingURL=handlers.js.map
